<!--
    EiToolingDetailsTabComponent Template

    Sections:
      - Parent-import card (navigation shortcut)
      - Record meta grid (timestamps, counters)
      - Review note (editable)
      - Primary actions (resume / re-lookup / mark irrelevant)
-->

<!-- Parent-Import Card -->
@if (parentImport) {
    <div class="surface-100 border-round p-3 mb-3">
        <div class="flex align-items-start justify-content-between gap-3">
            <div class="flex-1 min-w-0">
                <div class="text-sm text-600">Import</div>
                <div class="font-bold">
                    #{{ parentImport?.id ?? '–' }}
                    @if (parentImport?.importTypeDtoName) {
                        <span class="text-600 font-normal"> — {{ parentImport.importTypeDtoName }}</span>
                    }
                </div>
                <div class="text-xs mt-2 flex flex-wrap gap-1">
                    <p-tag [value]="phaseLabel"></p-tag>
                    <p-tag [value]="executionStatusLabel"></p-tag>
                </div>
            </div>
            <p-button
                    label="Zum Import"
                    icon="fa-solid fa-arrow-up-right-from-square"
                    [text]="true"
                    severity="secondary"
                    size="small"
                    (onClick)="navigateToImport()">
            </p-button>
        </div>
    </div>
}

<!-- Record Meta -->
<div class="grid mb-3">
    <div class="col-6">
        <div class="text-sm text-600">Angelegt</div>
        <div>{{ record?.createdDate ? (record.createdDate | date:'dd.MM.yyyy HH:mm') : '–' }}</div>
        @if (record?.createdBy) {
            <div class="text-xs text-500">{{ record.createdBy }}</div>
        }
    </div>
    <div class="col-6">
        <div class="text-sm text-600">Zuletzt geändert</div>
        <div>{{ record?.lastModifiedDate ? (record.lastModifiedDate | date:'dd.MM.yyyy HH:mm') : '–' }}</div>
        @if (record?.lastModifiedBy) {
            <div class="text-xs text-500">{{ record.lastModifiedBy }}</div>
        }
    </div>
    <div class="col-6">
        <div class="text-sm text-600">Re-Lookup-Anzahl</div>
        <div class="font-bold">{{ record?.reResolveCount ?? 0 }}</div>
    </div>
    <div class="col-6">
        <div class="text-sm text-600">Konflikte</div>
        <div class="font-bold">
            {{ record?.resolvedConflictCount ?? 0 }} / {{ record?.conflictCount ?? 0 }}
        </div>
    </div>
    @if (record?.errorMessage) {
        <div class="col-12">
            <div class="text-sm text-600">Fehlermeldung</div>
            <p-message severity="error" [text]="record.errorMessage" [closable]="false"></p-message>
        </div>
    }
</div>

<!-- Review Note -->
<div class="mb-3">
    <label class="text-sm text-600 block mb-1">Review-Notiz</label>
    <textarea pTextarea
              [(ngModel)]="editableNote"
              rows="3"
              class="w-full"
              placeholder="Notiz hinzufügen…">
    </textarea>
    <div class="flex justify-content-end mt-2">
        <p-button
                label="Notiz speichern"
                icon="fa-solid fa-save"
                size="small"
                [disabled]="noteIsUnchanged"
                (onClick)="saveNote()">
        </p-button>
    </div>
</div>

<!-- Actions -->
<div class="flex gap-2 flex-wrap">
    <p-button
            label="Pipeline fortsetzen"
            icon="fa-solid fa-play"
            severity="primary"
            (onClick)="confirmResume()">
    </p-button>
    <p-button
            label="Erneut auflösen"
            icon="fa-solid fa-magnifying-glass-plus"
            severity="info"
            (onClick)="confirmReLookup()">
    </p-button>
    <p-button
            label="Als irrelevant markieren"
            icon="fa-solid fa-ban"
            severity="warn"
            [text]="true"
            (onClick)="confirmMarkIrrelevant()">
    </p-button>
</div>
